// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2PSoI","bigColWidth":"Table_bigColWidth__oib-0","biggerColWidth":"Table_biggerColWidth__3qYAu","row":"Table_row__3Rds6","col":"Table_col__15j-K"};